import React, { useEffect, useState } from "react";
import Header from "../../../Layout/Header";
import { AppBar, Toolbar, Box,Tooltip, useTheme, Divider, Stack, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, FormControl, Button, CssBaseline, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Autocomplete } from "@mui/material";

import { tokens } from "../../../theme/theme";
import CustomTableContainer from "../../../Layout/CustomTableContainer";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import CallAlertBar from "../../../Layout/Alertbar";



import AppBarModule from "../../../Layout/AppbarModule";

// import SkeletonTableLoader from "../../productionmanagement/SkeletonTableLoader";
import useLocations from "../../../hooks/useLocations";
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import Close from '@mui/icons-material/Close';
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";


const ShiftRoasterForm = ({ handleBackWinderMachineEntry }) => {


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // state variable declartion
    const [shiftCode, setShiftCode] = useState('');
    const [shiftID, setShiftID] = useState('');
    const [selectedShiftCode, setSelectedShiftCode] = useState([]);
    const [checkInTime, setCheckInTime] = useState(null);
    const [checkOutTime, setCheckOutTime] = useState(null);
    const [durationMins, setDurationMins] = useState(0);
    const [editRosterID, setEditRosterID] = useState(0);
    const [description, setDescription] = useState('');
    const [newShift, setNewShift] = useState(false);
    const [startDate, setStartDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [endDate, setEndDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [shiftData, setShiftData] = useState([]);
    const [location, setLocation] = useState('');

    const [isDataLoaded, setIsDataLoaded] = useState(false);

    // departement
    const [departement, setDepartement] = useState([]);
    const [selectedDepartement, setSelectedDepartement] = useState([]);
    const [selectedDepartementID, setSelectedDepartementID] = useState(0);
    const [isDepartementDataLoaded, setIsDepartementDataLoaded] = useState(false);

    // departement
    const [rShiftCode, setRShiftCode] = useState([]);
    const [selectedRShiftCode, setSelectedRShiftCode] = useState([]);
    const [selectedRShiftCodeID, setSelectedRShiftCodeID] = useState(0);
    const [isRShiftCodeDataLoaded, setIsRShiftCodeDataLoaded] = useState(false);

    // message Process
    const [msgOpen, setMsgOpen] = useState(false);
    const [severityValue, setSeverityvalue] = useState('info');
    const [messageValue, setMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [alertTitleValue, setAlertTitleValue] = useState('');
    const [selectedButton, setSelectedButton] = useState(null);

    //skeleton page 
    const [loading, setLoading] = useState(false);
    const formatTime = (time) =>
        time ? new Date(time).toLocaleTimeString('en-US', { hour12: false }) : '00:00:00';

    const { locations, selectedLocation, selectedLocationID, setSelectedLocation, setSelectedLocationID, loadLocationByID } = useLocations(editRosterID);

    const handleShowNewVendor = () => {
        setNewShift(true);
        setShiftID(0);
        refreshData();

    }

    const refreshData = () => {
        setMsgOpen(false);
        setEditRosterID(0);
        setStartDate(null);
        setEndDate(null);
        setLocation('');
        //setBreakDurationMins(0);
    }

    // call message
    const CallMessage = (serverityval, msg, title) => {
        setSeverityvalue(serverityval);
        setMessageValue(msg);
        setAlertTitleValue(title);
        setMsgOpen(true);
    };

    // location change
    const handlechangeLocation = (event, value) => {
        setSelectedLocation(value);
        setSelectedLocationID(value.id);
    }

    const handleCallEdit = async (value) => {
        // setShiftID(value);
        setEditRosterID(value);
        setNewShift(true);
        loadShiftRoasterDetail(value);
    };


    // Load Shift code list
    useEffect(() => {
        if (!isDataLoaded) {

            const fetchData = async () => {
                const p_companyid = localStorage.getItem('companyid');

                const para = {
                    p_companyid: p_companyid,
                    p_plantid: 1,
                };
                setLoading(true);
                try {
                    const data = await callApi(API_ENDPOINTS.HR_SHIFT_ROASTER_MASTER_LIST, 'POST', { 'Content-Type': 'application/json' }, para);
                    if (data) setShiftData(data); setIsDataLoaded(true); // Set the fetched data to party list
                } catch (error) {
                    alert(error.message);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }
    })


    // Fetch shift codes function
    const fetchShiftCodes = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem('companyid') };
        try {
            const data = await callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_SHIFT_CODE, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data && data.length > 0) {
                setShiftCode(data);
                const initialShift = data.find(shift => shift.shiftid === selectedID) || data[0];
                setSelectedShiftCode(initialShift);
                setShiftID(initialShift.shiftid);
                setSelectedRShiftCodeID(initialShift.shiftid);
            }
        } catch (error) {
            CallMessage('error', error.message, 'Error');

        }
    };

    // UseEffect to load shift codes on component mount
    useEffect(() => {
        if (!isDataLoaded && editRosterID === 0) {
            fetchShiftCodes();
        }
    }, [isDataLoaded, editRosterID]);


    // Call fetchShiftCodes with selectedID
    const loadShiftCode = async (selectedID) => {
        await fetchShiftCodes(selectedID);
    };


    // Load department list
    const fetchDepartment = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem('companyid') };

        try {
            const data = await callApi(API_ENDPOINTS.DEPARTMENT_GET, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data && data.length > 0) {
                setDepartement(data); // Set the department data to state
                const initialShift = data.find(shift => shift.id === selectedID) || data[0];
                setSelectedDepartement(initialShift);
                setSelectedDepartementID(initialShift.id);
            }
        } catch (error) {
            CallMessage('error', error.message, 'Error');
        }
    };


    // load department
    useEffect(() => {
        if (!isDepartementDataLoaded && editRosterID === 0) {
            fetchDepartment();
        }
    }, [isDataLoaded, editRosterID]);

    // Call fetchdepartment with selectedID
    const loadDepartmentCode = async (selectedID) => {
        await fetchDepartment(selectedID);
    };



    // update selected shift code value
    const handleShiftChange = (event, value) => {
        setSelectedShiftCode(value);
        setShiftID(value.shiftid);
        setSelectedRShiftCodeID(value.shiftid);
    }

    // update selected shift code value
    const handleDepartmentChange = (event, value) => {
        setSelectedDepartement(value);
        setSelectedDepartementID(value.id);
    }

    // insert and update shift master detail
    const addShiftAsync = async () => {
        try {
            // Ensure shiftvalue is correctly assigned
            let shiftvalue = editRosterID || 0;
            let isvalid = true;

            // validation

            if (selectedRShiftCodeID === 0) {
                isvalid = false;
            }
            if (selectedDepartementID === 0) {
                isvalid = false;
            }
            if (selectedLocationID === 0) {
                isvalid = false;
            }

            if (startDate === endDate) {
                isvalid = false;
            }

            if (isvalid === true) {
                // Prepare API parameters
                const para = {
                    p_id_shift_roaster: shiftvalue,
                    p_id_shift: selectedRShiftCodeID,
                    p_id_department: selectedDepartementID,
                    p_start_date: dayjs(startDate).format('YYYY-MM-DD hh:mm:ss'),  // Default to valid time if empty
                    p_end_date: dayjs(endDate).format('YYYY-MM-DD hh:mm:ss'),
                    p_id_location: selectedLocationID,
                    p_created_by: localStorage.getItem('userID') || 'Unknown',  // Default value for safety
                    p_companyid: localStorage.getItem('companyid') || 0,  // Convert to integer if needed
                    p_plantid: 1,
                };

                // Determine the API endpoint
                let CallQuery = editRosterID === 0
                    ? API_ENDPOINTS.HR_SHIFT_ROASTER_MASTER_ADD
                    : API_ENDPOINTS.HR_SHIFT_ROASTER_MASTER_UPDATE;

                setLoading(true);  // Show loader before API call

                // Call the API and handle the response
                const data = await callApi(CallQuery, 'POST', { 'Content-Type': 'application/json' }, para);

                if (data?.length > 0) {
                    // Assuming you want to do something with the response                    
                    if (shiftvalue === 0) {
                        CallMessage('success', 'Shift roaster saved successfully', 'Info');
                        setShiftID(data[0].id);
                    }
                    else {
                        CallMessage('success', 'Shift roaster updates successfully', 'Info');
                    }

                }
            }
            else {
                CallMessage('warning', 'Please check Inputs', 'Warning');
            }

        } catch (error) {
            CallMessage('error', error.message || 'An error occurred', 'Error');
        } finally {
            setLoading(false);  // Hide loader after API call
        }
    };



    // duration calculation
    const handleCalculateDuration = () => {
        if (checkInTime && checkOutTime) {
            const duration = dayjs(checkOutTime).diff(dayjs(checkInTime), "minute");
            setDurationMins(duration);
        }
    };

    //call back Form
    const callback = () => {
        handleBackWinderMachineEntry();
    };

    const callBackNewShift = () => {
        setNewShift(false);
        setIsDataLoaded(false);
    };

    const loadShiftRoasterDetail = async (id) => {
        const p_companyid = localStorage.getItem('companyid');

        const para = {
            p_companyid: p_companyid,
            p_plantid: 1,
            p_id_shift_roaster: id,
        };
        setLoading(true);
        try {
            const data = await callApi(API_ENDPOINTS.HR_SHIFT_ROASTER_DETAIL, 'POST', { 'Content-Type': 'application/json' }, para);
            if (data) {

                setStartDate(data[0].start_at);
                setEndDate(data[0].end_at);
                setLocation(data[0].s_location); // Set the fetched data to party list

                await loadShiftCode(data[0].shift_id);
                await loadDepartmentCode(data[0].department_id);
                await loadLocationByID(data[0].location_id);
            }

        } catch (error) {
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box >

            {newShift === false && (
                <>
                    <AppBarModule
                        title="Shift Roaster Management"
                        menuOptions={['All Shift Roaster', 'Active Shift Roaster', 'Inactive Shift Roaster']}
                        onNewClick={() => handleShowNewVendor()}
                        onClose={() => callback()}
                    />


                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                        setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                        setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />
                </>
            )}

            <ResponsiveBox
                customMaxHeight={{
                    xs: '60vh',  // Custom value for extra small devices
                    sm: '65vh',  // Custom value for small devices
                    md: '70vh',  // Custom value for medium devices
                    lg: '81vh',  // Custom value for large devices
                    xl: '80vh',  // Custom value for extra large devices
                }}>

                <Grid>
                    {newShift === false && (
                        <>
                            <Grid item xs={12} sm={6} md={4} lg={2}>
                                <CustomTableContainer colors={colors}>
                                    <TableContainer>
                                        {loading ? (
                                            <SkeletonTableLoader rows={5} columns={6} />
                                        ) : (
                                            <Table>
                                                <TableHead sx={{ height: 10 }}>
                                                    <TableRow>
                                                        <TableCell>ROASTER ID</TableCell>
                                                        <TableCell>SHIFT CODE</TableCell>
                                                        <TableCell>DEPARTMENT</TableCell>
                                                        <TableCell>START AT</TableCell>
                                                        <TableCell>END AT</TableCell>
                                                        <TableCell>LOCATION</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {shiftData.map((s) => (
                                                        <React.Fragment key={s.id}>
                                                            <TableRow>
                                                                <TableCell>{s.id}</TableCell>
                                                                <TableCell>
                                                                    <span
                                                                        style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                                        onClick={() => handleCallEdit(s.id)}
                                                                    >
                                                                        {s.shift_code}
                                                                    </span>
                                                                </TableCell>
                                                                <TableCell>{s.description}</TableCell>
                                                                <TableCell>{s.start_date}</TableCell>
                                                                <TableCell>{s.end_date}</TableCell>
                                                                <TableCell>{s.location}</TableCell>
                                                            </TableRow>
                                                        </React.Fragment>
                                                    ))}

                                                </TableBody>
                                            </Table>
                                        )}
                                    </TableContainer>
                                </CustomTableContainer>
                            </Grid>
                        </>
                    ) || (
                            <>
                                <Grid item xs={12} sm={6} md={4} lg={2}  >                                   

                                    <Grid container justifyContent="space-between" alignItems="center" padding={0}>
                                        {/* Left-aligned: Edit Employee */}
                                        <Grid item>
                                            <Typography variant="h5" sx={{ textAlign: "center", width: "100%", marginLeft: "10px", alignItems: "center" }}>                                                
                                                Add Shift Roaster Detail
                                            </Typography>
                                        </Grid>

                                        {/* Right-aligned: Buttons */}
                                        <Grid item>
                                            <Grid container alignItems="center">
                                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                                                {/* Save */}
                                                <Grid item ml={1} mr={1}>
                                                    <Tooltip title="Add new orders">
                                                        <IconButton
                                                            onClick={() => addShiftAsync()}
                                                            sx={{ display: 'flex', alignItems: 'center' }}
                                                            type="submit"                                                        
                                                        >
                                                            <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                                            <Typography variant="body2" sx={{ ml: 1 }}>  {editRosterID === 0 ? 'Save' : 'Edit'}</Typography>
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>

                                                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                                                <IconButton onClick={callBackNewShift}>                                                    
                                                    <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                                                </IconButton>

                                                <Divider orientation="vertical" flexItem  />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Divider />
                                    <CallAlertBar parentRollMsgOpen={msgOpen} setParentRollMsgOpen={setMsgOpen} parentRollSeverityvalue={severityValue}
                                        setParentRollSeverityvalue={setSeverityvalue} parentRollAlertTitleValue={alertTitleValue}
                                        setParentRollAlertTitleValue={setAlertTitleValue} parentRollMessageValue={messageValue} setParentRollMessageValue={setMessageValue} />
                                </Grid>


                                {/* Add Form detail */}
                                <Grid item xs={12} sm={6} md={4} lg={2}>
                                    <Grid container>
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Shift Code
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <Autocomplete
                                                                fullWidth
                                                                value={selectedShiftCode}
                                                                onChange={handleShiftChange}
                                                                size="small"
                                                                style={{ fontSize: '12px' }}
                                                                options={shiftCode}
                                                                getOptionLabel={(option) => `${option.shiftcode || ''}`}
                                                                renderInput={(params) =>
                                                                    <TextField required
                                                                        {...params} variant="outlined" />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Departement
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <Autocomplete
                                                                fullWidth
                                                                value={selectedDepartement}
                                                                onChange={handleDepartmentChange}
                                                                size="small"
                                                                style={{ fontSize: '12px' }}
                                                                options={departement}
                                                                getOptionLabel={(option) => `${option.description || ''}`}
                                                                renderInput={(params) =>
                                                                    <TextField required
                                                                        {...params} variant="outlined" />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Start Date
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <Stack spacing={1}>
                                                                    <DatePicker
                                                                        value={dayjs(startDate)} // Ensure shiftDate is a valid Day.js object or compatible string
                                                                        onChange={(date) => setStartDate(date)}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                variant: "outlined",
                                                                                fullWidth: true, // Add fullWidth here if needed
                                                                            },
                                                                        }}
                                                                        format="DD-MMM-YYYY" // For date formatting
                                                                        minDate={dayjs().subtract(4, 'year')}
                                                                        maxDate={dayjs().add(1, 'year')}
                                                                    />
                                                                </Stack>
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            End Date
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>
                                                        <FormControl fullWidth size="small">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <Stack spacing={1}>
                                                                    <DatePicker
                                                                        value={dayjs(endDate)} // Ensure shiftDate is a valid Day.js object or compatible string
                                                                        onChange={(date) => setEndDate(date)}
                                                                        slotProps={{
                                                                            textField: {
                                                                                size: "small",
                                                                                variant: "outlined",
                                                                                fullWidth: true, // Add fullWidth here if needed
                                                                            },
                                                                        }}
                                                                        format="DD-MMM-YYYY" // For date formatting
                                                                        minDate={dayjs().subtract(4, 'year')}
                                                                        maxDate={dayjs().add(1, 'year')}
                                                                    />
                                                                </Stack>
                                                            </LocalizationProvider>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >

                                                    <Grid item xs={12} sm={12} md={2.5} lg={1.5} xl={1} display="flex-start" justifyContent="center">
                                                        <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                                            Location
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} sm={11} md={3.8} lg={3} xl={2}>

                                                        <FormControl fullWidth size="small">
                                                            <Autocomplete
                                                                fullWidth
                                                                value={selectedLocation}
                                                                onChange={handlechangeLocation}
                                                                size="small"
                                                                style={{ fontSize: '12px' }}
                                                                options={locations}
                                                                getOptionLabel={(option) => `${option.description || ''}`}
                                                                renderInput={(params) =>
                                                                    <TextField required
                                                                        {...params} variant="outlined" />}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                            </Grid>





                                        </Grid>

                                        {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                <Grid container padding="10px 0px 10px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex-start" justifyContent="center">
                                                        <Divider />
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Box sx={{ display: "flex", justifyContent: "flex-end", marginRight: "10px" }}>
                                                    <Button variant="contained" onClick={() => addShiftAsync()} color="secondary" size="small">{editRosterID === 0 ? 'Save' : 'Edit'}</Button>
                                                </Box>
                                            </Grid>
                                        </Grid> */}

                                    </Grid>
                                </Grid>
                            </>
                        )}
                </Grid>

            </ResponsiveBox>
        </Box>
    );

}
export default ShiftRoasterForm;